import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

export default function RouteErrorBoundary() {
  const error = useRouteError();

  let message = 'An unexpected error occurred.';
  if (isRouteErrorResponse(error)) {
    message = `${error.status} — ${error.statusText || 'Error'}`;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        background: 'var(--color-page-bg, #f8fafc)',
        color: 'var(--color-text-primary, #0f172a)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
        Something went wrong
      </h1>
      <p
        style={{
          color: 'var(--color-text-secondary, #475569)',
          maxWidth: '24rem',
          marginBottom: '1.5rem',
        }}
      >
        {message}
      </p>
      <Link
        to="/"
        style={{
          padding: '0.625rem 1rem',
          background: 'var(--color-primary, #0f172a)',
          color: '#ffffff',
          textDecoration: 'none',
          borderRadius: '8px',
          fontWeight: 500,
        }}
      >
        Return to home
      </Link>
    </div>
  );
}
